import cn from "classnames";

export const MoonSvgSmall = ({ isSelected }) => {
    const color = isSelected ? "#34303D" : "#716E77";
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1431_7588)">
                <path
                    d="M20.048 34.1666C16.0993 34.1666 12.751 32.7927 10.0031 30.0448C7.25528 27.2969 5.88135 23.9487 5.88135 20C5.88135 16.7116 6.89896 13.7885 8.93418 11.2308C10.9694 8.67315 13.6804 7.02464 17.0671 6.28531C17.7402 6.1165 18.2632 6.28103 18.636 6.77889C19.0089 7.27675 19.0404 7.82375 18.7306 8.41989C18.3866 9.04594 18.1312 9.69765 17.9646 10.375C17.7979 11.0523 17.7146 11.7607 17.7146 12.5C17.7146 15.235 18.6697 17.5577 20.58 19.468C22.4902 21.3782 24.8129 22.3333 27.548 22.3333C28.3663 22.3333 29.1484 22.2297 29.8941 22.0225C30.6398 21.8152 31.2926 21.5748 31.8524 21.3013C32.3823 21.062 32.8727 21.1 33.3236 21.4151C33.7744 21.7303 33.9368 22.2095 33.8107 22.8526C33.2188 26.1304 31.6242 28.8354 29.0271 30.9679C26.4299 33.1004 23.4368 34.1666 20.048 34.1666Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1431_7588">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const LedSvgSmall = ({ isSelected }) => {
    const color = isSelected ? "#34303D" : "#716E77";

    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.0007 27.4998C17.9195 27.4998 16.1492 26.7701 14.6898 25.3108C13.2304 23.8513 12.5007 22.081 12.5007 19.9999C12.5007 17.9187 13.2304 16.1484 14.6898 14.689C16.1492 13.2296 17.9195 12.4999 20.0007 12.4999C22.0818 12.4999 23.8521 13.2296 25.3115 14.689C26.7709 16.1484 27.5006 17.9187 27.5006 19.9999C27.5006 22.081 26.7709 23.8513 25.3115 25.3108C23.8521 26.7701 22.0818 27.4998 20.0007 27.4998ZM3.33398 21.2498C2.97982 21.2498 2.68296 21.13 2.4434 20.8903C2.20379 20.6506 2.08398 20.3536 2.08398 19.9993C2.08398 19.645 2.20378 19.3482 2.44336 19.1089C2.68291 18.8696 2.97978 18.7499 3.33394 18.7499H7.08398C7.43812 18.7499 7.73498 18.8698 7.97457 19.1094C8.21418 19.3491 8.33398 19.6461 8.33398 20.0004C8.33398 20.3548 8.21419 20.6516 7.97461 20.8909C7.73503 21.1302 7.43817 21.2498 7.08403 21.2498H3.33398ZM32.9173 21.2498C32.5631 21.2498 32.2663 21.13 32.0267 20.8903C31.7871 20.6506 31.6673 20.3536 31.6673 19.9993C31.6673 19.645 31.7871 19.3482 32.0267 19.1089C32.2663 18.8696 32.5631 18.7499 32.9173 18.7499H36.6673C37.0215 18.7499 37.3184 18.8698 37.5579 19.1094C37.7975 19.3491 37.9173 19.6461 37.9173 20.0004C37.9173 20.3548 37.7975 20.6516 37.5579 20.8909C37.3184 21.1302 37.0215 21.2498 36.6673 21.2498H32.9173ZM20.0001 8.33321C19.6458 8.33321 19.349 8.21342 19.1097 7.97384C18.8703 7.73425 18.7507 7.43739 18.7507 7.08325V3.33321C18.7507 2.97904 18.8705 2.68217 19.1102 2.44259C19.3499 2.20303 19.6469 2.08325 20.0012 2.08325C20.3555 2.08325 20.6523 2.20303 20.8917 2.44259C21.131 2.68217 21.2506 2.97904 21.2506 3.33321V7.08325C21.2506 7.43739 21.1308 7.73425 20.8911 7.97384C20.6514 8.21342 20.3544 8.33321 20.0001 8.33321ZM20.0001 37.9165C19.6458 37.9165 19.349 37.7967 19.1097 37.5571C18.8703 37.3176 18.7507 37.0207 18.7507 36.6665V32.9165C18.7507 32.5624 18.8705 32.2655 19.1102 32.0259C19.3499 31.7863 19.6469 31.6665 20.0012 31.6665C20.3555 31.6665 20.6523 31.7863 20.8917 32.0259C21.131 32.2655 21.2506 32.5624 21.2506 32.9165V36.6665C21.2506 37.0207 21.1308 37.3176 20.8911 37.5571C20.6514 37.7967 20.3544 37.9165 20.0001 37.9165ZM10.0103 11.7338L7.91415 9.69533C7.66629 9.46456 7.54662 9.1745 7.55515 8.82517C7.56371 8.47581 7.685 8.17186 7.91903 7.91333C8.1743 7.65478 8.47394 7.5255 8.81794 7.5255C9.16197 7.5255 9.45471 7.65478 9.69615 7.91333L11.7507 9.9935C11.9921 10.2521 12.1128 10.5448 12.1128 10.8717C12.1128 11.1986 11.9948 11.4913 11.7587 11.7499C11.5226 12.0084 11.2368 12.1307 10.9013 12.1168C10.5658 12.1029 10.2688 11.9752 10.0103 11.7338ZM30.3052 32.0863L28.2507 30.0063C28.0092 29.7477 27.8885 29.4507 27.8885 29.1153C27.8885 28.7798 28.0092 28.4913 28.2507 28.2499C28.4761 27.9913 28.7578 27.869 29.096 27.8829C29.4341 27.8968 29.7325 28.0245 29.991 28.2659L32.0872 30.3044C32.335 30.5352 32.4547 30.8252 32.4462 31.1745C32.4376 31.5239 32.3163 31.8278 32.0823 32.0864C31.827 32.3449 31.5274 32.4742 31.1834 32.4742C30.8393 32.4742 30.5466 32.3449 30.3052 32.0863ZM28.2507 11.7579C27.9921 11.5218 27.8698 11.236 27.8837 10.9005C27.8976 10.5651 28.0252 10.2681 28.2667 10.0095L30.3052 7.91338C30.5359 7.66552 30.826 7.54585 31.1753 7.55438C31.5247 7.56293 31.8286 7.68423 32.0872 7.91825C32.3457 8.17353 32.475 8.47317 32.475 8.81717C32.475 9.1612 32.3457 9.45393 32.0872 9.69538L30.007 11.7499C29.7485 11.9913 29.4557 12.112 29.1288 12.112C28.8019 12.112 28.5092 11.994 28.2507 11.7579ZM7.91415 32.0899C7.6556 31.829 7.52632 31.5266 7.52632 31.1826C7.52632 30.8386 7.6556 30.5458 7.91415 30.3044L9.99428 28.2499C10.2528 28.0084 10.5498 27.8877 10.8853 27.8877C11.2207 27.8877 11.5092 28.0084 11.7507 28.2499C11.9985 28.4753 12.1155 28.7571 12.1016 29.0952C12.0877 29.4333 11.9654 29.7317 11.7346 29.9902L9.69615 32.0864C9.45471 32.3449 9.16197 32.4699 8.81794 32.4614C8.47394 32.4528 8.17268 32.329 7.91415 32.0899Z"
                fill={color}
            />
        </svg>
    );
};

export const BellSvgSmall = ({ isSelected }) => {
    const color = isSelected ? "#34303D" : "#716E77";

    return (
        <svg
            className="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M17.133 12.632v-1.8a5.406 5.406 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.955.955 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175ZM6 6a1 1 0 0 1-.707-.293l-1-1a1 1 0 0 1 1.414-1.414l1 1A1 1 0 0 1 6 6Zm-2 4H3a1 1 0 0 1 0-2h1a1 1 0 1 1 0 2Zm14-4a1 1 0 0 1-.707-1.707l1-1a1 1 0 1 1 1.414 1.414l-1 1A1 1 0 0 1 18 6Zm3 4h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z"
                fill={color}
            />
        </svg>
    );
};

export const PuzzleSvg = (props) => {
    const { color, height, width, className } = props;

    return (
        <svg
            className={cn("inline", className)}
            fill={color || "#000000"}
            height={height || "24px"}
            width={width || "24px"}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 492.308 492.308"
            xmlSpace="preserve"
        >
            <g>
                <g>
                    <path
                        d="M412.577,166.421c-10.452,0-23.591,4.726-33.553,9.125V56.642H0l0.005,151.524l14.649-8.188
			c9.591-5.361,28.553-13.865,38.591-13.865c33.106,0,60.038,26.933,60.038,60.038S86.351,306.19,53.245,306.19
			c-10.034,0-28.995-8.51-38.591-13.87L0,284.127v151.538h379.024V316.748c9.962,4.404,23.101,9.135,33.553,9.135
			c43.962,0,79.731-35.769,79.731-79.731S456.538,166.421,412.577,166.421z M412.577,306.19c-10.034,0-28.99-8.514-38.587-13.885
			l-14.659-8.197v131.865H19.692v-99.221c9.962,4.404,23.101,9.13,33.553,9.13c43.962,0,79.731-35.769,79.731-79.731
			s-35.769-79.731-79.731-79.731c-10.452,0-23.591,4.726-33.553,9.125V76.334h339.639v131.861l14.659-8.212
			c6.423-3.601,27.298-13.87,38.587-13.87c33.106,0,60.038,26.933,60.038,60.038S445.683,306.19,412.577,306.19z"
                    />
                </g>
            </g>
        </svg>
    );
};


export const DownArrowSvg = ({ className }) => {

    return (
        <svg width="56px" height="56px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3Z" fill="rgb(59 130 246)" />
        </svg>
    );
};

export const CrossSvg = ({ className }) => {

    return (
        <svg className={className} fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 490 490" xmlSpace="preserve">
            <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 
	489.292,457.678 277.331,245.004 489.292,32.337 "/>
        </svg>
    );
};

export const BluetoothSvg = ({ className, height, width }) => {
    return (
        <svg className={className} height={height || "24px"} width={width || "24px"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5282 6.5C20.4641 8.11795 20.9998 9.99642 20.9998 12C20.9998 14.0036 20.4641 15.882 19.5282 17.5M16.3262 9C16.7581 9.90926 16.9998 10.9264 16.9998 12C16.9998 13.0736 16.7581 14.0907 16.3262 15M3 17L8 12M8 12L13 7L8 2V12ZM8 12V22L13 17L8 12ZM8 12L3 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}